import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';

interface Params {
    shopId: string;
}

declare module '@stackflow/config' {
    interface Register {
        ItemSoldOutModal: Params;
    }
}

const ItemSoldOutModal: ActivityComponentType<'ItemSoldOutModal'> = ({ params }) => {
    const { shopId } = params;
    const { pop, replace } = useFlow();
    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth spacing={24} align='center'>
                    <Text size='lg' align='center'>
                      해당 상품 주문이 어렵습니다.<br/>
                      해당 매장에서 다른 상품을 주문하시겠습니까?
                    </Text>
                    <Row fullWidth spacing={10}>
                        <Button onClick={pop}
                            fullWidth
                            variant='secondary'>
                          취소
                        </Button>
                        <Button fullWidth
                            onClick={() => replace('ItemsActivity', { shopId, type: 'ALL' })} >
                          확인
                        </Button>
                    </Row>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default ItemSoldOutModal;
